module.exports = __webpack_public_path__ + "img/very_rare_attunement_image.fd725a65.png";